<ng-sidebar-container>
    <!-- A sidebar -->
    <ng-sidebar #sidebar [(mode)]="sidebarMode" [(opened)]="isSidebarOpen">
        <sidebar
            (onItemClick)="onItemClick($event)"
            (onSidebarLoaded)="refreshSidebar()"
            (onSidebarToggle)="toggleSidebar()"
        ></sidebar>
    </ng-sidebar>

    <!-- Page content -->
    <div ng-sidebar-content>
        <header [headerButtons]="headerButtons" (onSidebarToggle)="toggleSidebar()"></header>
        <router-outlet></router-outlet>
    </div>
</ng-sidebar-container>
